<template>
  <div class="container-fluid">
    <div
      class="row align-items-center justify-content-center"
      style="min-height: 65vh"
      v-if="loading"
    >
      <div class="col-1">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-12 mb-2 d-none">
        <h3 class="click btn-link text-muted" @click="back()">
          &#8592; VOLVER
        </h3>
      </div>

      <div class="col-12">
        <h2 class="text-uppercase font-weight-bold d-none">
          {{ product.name }}
        </h2>
      </div>

      <div class="col-12 col-md-5" v-if="product.image">
        <div class="text-center border product-image">
          <img
            :src="getImage(product.image)"
            class="img-fluid"
            alt="imagen"
            loading="lazy"
            style="width: 100%"
          />
        </div>
      </div>

      <div class="col py-0">
        <small class="text-muted">REF: {{ product.code }}</small>
        <h2 class="text-uppercase font-weight-bold d-none1 product-title">
          {{ product.name }}
        </h2>

        <div
          class="badge badge-danger d-block w-100 py-2 product-description"
        >
          <small
            class="d-block text-secondary promo-old-price"
            v-if="getDiscount > 0"
          >
            <s>${{ formatNumber(total) }}</s>
          </small>
          <strong class="d-block">
            ${{ formatNumber(total - getDiscount) }}
          </strong>
        </div>
        <div
          class="alert alert-primary text-center"
          v-if="getPromos"
        >
          <strong class="d-block">Oferta disponible</strong>
          <small class="d-block" style="white-space: break-spaces">
            {{ getPromos }}
          </small>
        </div>
        <div
          class="alert alert-primary text-center"
          v-if="getAvaiable"
        >
          <strong>Disponible: {{ getAvaiable }}</strong>
        </div>
        <div class="w-100 py-3"></div>
        <small class="d-block text-muted text-uppercase">descripcion</small>
        <div class="my-1 bg-white1">
          <span
            class="d-block font-weight-bold px-0"
            style="font-family: sans-serif; white-space: break-spaces"
            >{{ product.description || "- - - - -" }}</span
          >
        </div>
      </div>
      <div class="col-12">
        <div class="my-4">
          <div
            class="row border-bottom py-2 px-0 option-block"
            v-for="(op, i) in options"
            :key="i"
            :ref="`option-block-${i}`"
            :class="{
              'option-block--active': useAccordion && isOptionOpen(i),
              'option-block--done': useAccordion && !isOptionOpen(i) && isOptionComplete(op),
            }"
          >
            <div
              class="col-12 font-weight-bold"
              :class="{ click: useAccordion }"
              @click="useAccordion ? openOption(i) : null"
            >
              <div class="d-flex align-items-start justify-content-between">
                <div class="pr-3">
                  <span class="text-uppercase mr-2">{{ op.displayLabel || op.label || op.name }}</span>
                  <div class="w-100"></div>
                  <div
                    class="badge badge-danger mb-1"
                    v-if="op.min > 0 || !op.multiple"
                  >
                    <small>OBLIGATORIO</small>
                  </div>
                  <div class="badge badge-info" v-else>
                    <small>OPCIONAL</small>
                  </div>
                </div>
                <div v-if="useAccordion" class="text-right option-status">
                  <small
                    class="d-block font-weight-bold"
                    :class="isOptionComplete(op) ? 'text-success' : 'text-muted'"
                  >
                    {{ isOptionComplete(op) ? "Listo" : "Pendiente" }}
                  </small>
                  <small class="text-muted d-block">{{ i + 1 }}/{{ options.length }}</small>
                </div>
              </div>
              <div class="w-100"></div>
              <small class="text-uppercase py-1 d-block option-summary"
                >Seleccionaste:
                <strong>{{ getSelected(op.selected) }}</strong></small
              >
              <div class="w-100"></div>
              <small class="text-muted" v-if="op.multiple"
                >Puedes elegir entre {{ op.min }} - {{ op.max }} opciones</small
              >
              <small
                class="text-primary d-block mt-1"
                v-if="useAccordion && !isOptionOpen(i)"
              >
                Toca para {{ isOptionComplete(op) ? "editar" : "continuar selección" }}
              </small>
            </div>
            <div class="col-12 pt-2" v-show="!useAccordion || isOptionOpen(i)">
              <div class="alert alert-light border py-2 px-3 mb-2" v-if="useAccordion">
                <small class="text-muted d-block">{{ getOptionGuide(op) }}</small>
              </div>
            <div class="col-12 px-0" v-if="op.type == 'select'">
              <div class="row no-gutters px-0">
                <div
                  class="col-6 col-md-4 px-1 py-1"
                  v-for="(val, i) in op.options"
                  :key="val._id"
                >
                  <b-dropdown
                    v-if="val.optionGroup"
                    :id="`dropdown-${i}`"
                    :text="`${val.name} ${getSelectedText(
                      op.selected,
                      op,
                      val
                    )}`"
                    :menu-class="{
                      'text-uppercase': 1,
                    }"
                    :toggle-class="{
                      'text-uppercase h-100': 1,
                    }"
                    size="sm"
                    block
                    class="h-100 text-uppercase"
                    :variant="
                      op.parent == val._id ? 'secondary' : 'outline-secondary'
                    "
                  >
                    <b-dropdown-item
                      :key="i"
                      class="h-100"
                      :class="{
                        'text-danger': !s._id.enabled,
                      }"
                      v-for="(s, i) in val.optionGroup.options"
                      @click="setOption(op, s._id, val._id)"
                      :disabled="!s._id.enabled"
                    >
                      {{ s._id.name }}
                      <span v-if="s._id.value"
                        >- ${{ s._id.value | formatNumber }}</span
                      >
                      <div class="w-100"></div>
                      <small
                        v-if="!s._id.enabled"
                        class="text-danger text-uppercase"
                        >(No disponible)</small
                      >
                    </b-dropdown-item>
                  </b-dropdown>
                  <button
                    v-else
                    @click="setOption(op, val)"
                    :class="{
                      'btn-secondary font-weight-bold':
                        op.selected == val || isIn(op, val),
                      'btn-outline-secondary ':
                        op.selected != val && !isIn(op, val),
                    }"
                    class="btn btn-block btn h-100 text-uppercase"
                    :disabled="
                      !val.enabled ||
                      (!isIn(op, val) &&
                        op.max == op.selected.length &&
                        op.selected.length != 0)
                    "
                  >
                    {{ val.name }}
                    <span v-if="val.value"> ${{ val.value }}</span>
                    <div class="w-100"></div>
                    <small
                      v-if="!val.enabled"
                      class="text-danger font-weight-bold text-uppercase"
                      >(No disponible)</small
                    >
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12 px-0" v-if="op.type == 'number'">
              <div class="d-flex flex-wrap align-items-center mb-2 number-shortcuts">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm mr-2 mb-2"
                  @click="setNumberOptionValue(op, op.min)"
                >
                  Min {{ op.min }}
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm mr-2 mb-2"
                  @click="decrementNumberOption(op)"
                  :disabled="Number(op.selected) <= Number(op.min)"
                >
                  -1
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm mr-2 mb-2"
                  @click="incrementNumberOption(op)"
                  :disabled="Number(op.selected) >= Number(op.max)"
                >
                  +1
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm mb-2"
                  @click="setNumberOptionValue(op, op.max)"
                >
                  Max {{ op.max }}
                </button>
              </div>
              <input
                type="number"
                class="form-control"
                :min="op.min"
                :max="op.max"
                @focus="$event.target.select()"
                v-model.number="op.selected"
                :class="{
                  'is-valid': op.min <= op.selected || op.max >= op.selected,
                  'is-invalid': op.max < op.selected || op.min > op.selected,
                }"
              />
              <span class="text-muted">
                Numero entre {{ op.min }} y {{ op.max }}
              </span>
            </div>
              <div
                class="d-flex justify-content-end pt-3"
                v-if="useAccordion && canContinueOption(op)"
              >
                <button
                  class="btn btn-sm btn-success px-3"
                  @click="continueFromOption(i)"
                >
                  {{ i === options.length - 1 ? "Finalizar opciones" : "Continuar" }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="py-3"
          id="product-notes"
          v-if="info.settings && info.settings.style == 'delivery'"
        >
          <span class="font-weight-bold">Notas adicionales (opcional)</span>
          <textarea
            class="form-control"
            v-model="details"
            cols="10"
            rows="3"
            placeholder="Opcional"
          ></textarea>
        </div>
        <div class="w-100 my-2"></div>
        <div class="">
          <div class="row no-gutters align-items-end px-1">
            <div class="col col-md ml-auto">
              <small>CANTIDAD</small>
              <b-form-spinbutton
                v-model="qty"
                min="1"
                step="1"
                size="lg"
                class="w-100"
                :max="product.stock ? product.qty : 20"
              ></b-form-spinbutton>
            </div>
            <div class="w-100 py-2"></div>
            <div class="col-12 col-md" v-if="product.enabled">
              <button
                class="btn btn-block py-3 h-100 btn-primary font-weight-bold"
                @click="addToCart()"
                :disabled="product.stock && product.qty <= 0"
              >
                <span v-if="product.stock && product.qty <= 0"
                  >PRODUCTO SIN STOCK</span
                >
                <span v-else>{{ isEditingCartProduct ? "GUARDAR CAMBIOS" : "AGREGAR" }}</span>
              </button>
            </div>
            <div class="col-12 col-md" v-if="!product.enabled">
              <button
                class="btn btn-block py-3 h-100 btn-primary font-weight-bold"
                disabled
              >
                PRODUCTO NO DISPONIBLE
              </button>
            </div>
          </div>

          <div
            v-for="(item, i) in pagecomponents"
            class="content c0"
            :key="`item-${i}`"
          >
            <components :item="item" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.promo-old-price {
  color: rgba(255, 255, 255, 0.8) !important;
  font-size: 0.8rem;
  line-height: 1.1;
}

.option-block {
  padding: 0.2rem 0.25rem;
  border-radius: 12px;
  transition: background-color 0.2s ease;
}

.option-block--active {
  background: linear-gradient(180deg, #f8fbff 0%, #eef6ff 100%);
  border: 1px solid #93c5fd !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.14);
}

.option-block--done {
  background: #f8fafc;
}

.option-status {
  min-width: 72px;
}

.option-summary {
  color: #334155;
}

.number-shortcuts .btn {
  min-width: 72px;
  font-weight: 600;
}
</style>

<script>
//import components from "../components/components";
const components = () => import("../components/components");

export default {
  components: {
    components,
  },
  props: ["id", "textColor", "editing"],
  data() {
    return {
      loading: true,
      product: {
        ref: {},
      },
      options: [],
      activeOptionIndex: 0,
      details: "",
      qty: 1,
      notes: "",
      hydratingDraft: false,
    };
  },
  computed: {
    isEditingCartProduct() {
      if (this.editing) return true;
      const editingCartProduct = this.$store.state.editingCartProduct;
      return !!(
        editingCartProduct &&
        `${editingCartProduct.productId}` === `${this.id}`
      );
    },
    useAccordion() {
      return this.options.length > 5;
    },
    getAvaiable() {
      const values = this.product.available_on
      console.log({values})

      if(!values) return false
      let rs = "";

      if (values.length == 1) {
        const [value] = values;
        if (value == "pickup") rs = "Solo retiro";
        if (value == "delivery") rs = "Solo Delivery";
        if (value == "shipping") rs = "Solo Envio";
      } 
      else {
        //rs += "Disponible: "
        values.forEach((value) => {
          
          if (value == "pickup") rs += "Retiro ";
          if (value == "delivery") rs += "- Domicilio ";
          if (value == "shipping") rs += "- Envio ";
        });
      }

      return rs;
    },

    pagecomponents() {
      return this.$store.state.components;
    },
    getPromos() {
      const promos = this.product.promos;
      const value = this.product.value;

      let rs = "";

      console.log({ promos });

      if (promos) {
        promos.forEach((promo) => {
          rs += this.getPromo(promo, value);
        });
      }

      if(rs == 'undefined') return false
      return rs;
    },
    settings() {
      return this.info && this.info.settings ? this.info.settings : {};
    },
    info() {
      return this.$store.state.info;
    },
    textClass() {
      return this.textColor || "text-white";
    },
    getExtras() {
      let values = new Set();

      this.options.forEach((o) => {
        if (o.selected == "" || o.selected == null) {
          //
        } else {
          if (o.selected && o.selected.value) {
            values.add(o.selected.value);
          }
          if (o.multiple) {
            o.selected.forEach((_o) => {
              if (_o && _o.value) {
                values.add(_o.value);
              }
            });
          }
        }
      });

      return values;
    },
    getDiscount() {
      let discount = 0;
      let qty = this.qty;
      if (this.product.promos && this.product.promos.length > 0) {
        console.log("hay promos");
        let enabledPromos = this.product.promos.filter((p) => p.enabled);
        //let product = this.product;
        // apply discount for each promo enabled
        enabledPromos.forEach((promo) => {
          console.log({ promo });
          // descuento cuando es a la cantidad
          if (promo.when == "qty") {
            if (this.checkCondition(qty, promo.is, promo.value)) {
              // el descuento afecta al total
              if (promo.to == "total") {
                if (promo.in == "%") {
                  discount = (this.total * promo.discount) / 100;
                }
                if (promo.in == "$") {
                  discount = promo.discount;
                }
              } else if (promo.to == "product") {
                // if (promo.in == "%") {
                //   discount = (promo.discount * 100) / (product.value * qty);
                // }
                if (promo.in == "$") {
                  console.log({
                    qty: qty,
                    discount: promo.discount,
                  });
                  discount = qty * promo.discount;
                }
              }
            }
          }

          // descuento cuando la total es
          if (promo.when == "total") {
            // ???
          }

          if (promo.when == "minopcion" && [this.getExtras].length > 0) {
            if (promo.to == "option") {
              let filterExtras = [...this.getExtras].filter(
                (e) => e > promo.value
              );

              console.log({ filterExtras });

              if (filterExtras.length == 0) {
                console.log("no filter extras");
                return discount;
              } else {
                if (promo.in == "$") {
                  discount = promo.discount;
                }
                if (promo.in == "%") {
                  //discount = (this.total * promo.discount) / 100;
                }
                discount = Math.min(...filterExtras);
              }
            }
          }
        });
      }
      console.log({ discount });
      // TODO: verificar el descuento cuando la cantidad sea mayor a 1
      return discount;
    },
    total() {
      let t = 0;

      this.options.forEach((o) => {
        if (o.selected == "" || o.selected == null) {
          //
        } else {
          if (o.selected && o.selected.value) {
            t = t + o.selected.value;
          }
          if (o.multiple) {
            o.selected.forEach((_o) => {
              if (_o && _o.value) {
                t = t + _o.value;
              }
            });
          }
        }
      });

      return (this.product.value + t) * this.qty;
    },
  },
  methods: {
    getProductDraft() {
      return this.$store.state.productDrafts[this.id] || null;
    },
    getDraftSelectableValue(op, selectedId) {
      if (!op || !selectedId) return null;
      const direct = (op.options || []).find((value) => `${value._id}` === `${selectedId}`);
      if (direct) return direct;

      for (const value of op.options || []) {
        if (!value.optionGroup || !value.optionGroup.options) continue;
        const nested = value.optionGroup.options.find((entry) => `${entry._id._id}` === `${selectedId}`);
        if (nested) return nested._id;
      }

      return null;
    },
    getDraftSelectableValueByName(op, selectedName) {
      if (!op || !selectedName) return null;
      const normalizedName = `${selectedName}`.trim().toLowerCase();
      const direct = (op.options || []).find(
        (value) => `${value.name || ""}`.trim().toLowerCase() === normalizedName
      );
      if (direct) return direct;

      for (const value of op.options || []) {
        if (!value.optionGroup || !value.optionGroup.options) continue;
        const nested = value.optionGroup.options.find((entry) => {
          const optionValue = entry && entry._id ? entry._id : {};
          return `${optionValue.name || ""}`.trim().toLowerCase() === normalizedName;
        });
        if (nested) return nested._id;
      }

      return null;
    },
    getDraftOptionKey(option = {}) {
      return `${option.label || option.name || ""}`.trim().toLowerCase();
    },
    applyProductDraft() {
      const draft = this.getProductDraft();
      if (!draft) return;

      this.hydratingDraft = true;
      this.qty = Number(draft.qty) || 1;
      this.details = draft.details || "";
      this.activeOptionIndex = Number.isInteger(draft.activeOptionIndex)
        ? draft.activeOptionIndex
        : 0;

      (draft.options || []).forEach((savedOption, savedIndex) => {
        const savedOptionKey = this.getDraftOptionKey(savedOption);
        const currentOption =
          (Number.isInteger(savedOption.draftIndex) &&
          this.options[savedOption.draftIndex]
            ? this.options[savedOption.draftIndex]
            : null) ||
          this.options.find((option) => {
            if (`${option._id}` === `${savedOption._id}`) return true;
            if (savedOption.refId && `${option.refId}` === `${savedOption.refId}`) return true;
            return this.getDraftOptionKey(option) === savedOptionKey;
          }) ||
          this.options[savedIndex];
        if (!currentOption) return;

        currentOption.parent = savedOption.parent || null;

        if (currentOption.type == "number") {
          currentOption.selected = Number(savedOption.selected);
          return;
        }

        if (currentOption.multiple) {
          const selectedValues =
            (savedOption.selectedIds || [])
              .map((selectedId) => this.getDraftSelectableValue(currentOption, selectedId))
              .filter(Boolean);

          currentOption.selected = (
            selectedValues.length > 0
              ? selectedValues
              : (savedOption.selectedNames || [])
                .map((selectedName) => this.getDraftSelectableValueByName(currentOption, selectedName))
                .filter(Boolean)
          );
          return;
        }

        currentOption.selected =
          this.getDraftSelectableValue(currentOption, savedOption.selectedId) ||
          this.getDraftSelectableValueByName(currentOption, savedOption.selectedName) ||
          "";
      });

      this.$nextTick(() => {
        this.hydratingDraft = false;
      });
    },
    persistProductDraft() {
      if (this.hydratingDraft || !this.id) return;

      const draft = {
        qty: this.qty,
        details: this.details,
        activeOptionIndex: this.activeOptionIndex,
        options: this.options.map((option) => ({
          _id: option._id,
          refId: option.refId || option._id,
          draftIndex: this.options.indexOf(option),
          label: option.label || option.name || "",
          name: option.name || option.label || "",
          type: option.type,
          multiple: option.multiple,
          parent: option.parent || null,
          selected:
            option.type == "number"
              ? Number(option.selected)
              : option.multiple
                ? undefined
                : option.selected && option.selected._id
                  ? option.selected._id
                  : option.selected,
          selectedId:
            !option.multiple && option.type != "number" && option.selected && option.selected._id
              ? option.selected._id
              : null,
          selectedIds: option.multiple
            ? (option.selected || []).map((selected) => selected && selected._id).filter(Boolean)
            : [],
          selectedName:
            !option.multiple && option.type != "number"
              ? (option.selected && option.selected.name ? option.selected.name : option.selected || "")
              : "",
          selectedNames: option.multiple
            ? (option.selected || []).map((selected) => selected && selected.name).filter(Boolean)
            : [],
        })),
      };

      this.$store.commit("setProductDraft", {
        productId: this.id,
        draft,
      });
    },
    load() {
      const pid = this.id;
      const { webName: _id } = this.$store.state.info;
      this.$http
        .get(`${_id}/product/${pid}`)
        .then((res) => {
          this.product = res.data.data;
          this.$store.commit("setProduct", res.data.data);
          console.log(res.data.data);
          document.title = `${res.data.data.name.toUpperCase()} `;
          this.options =
            res.data.data.newOptions ?
            res.data.data.newOptions.map((o, optionIndex) => {
              let op = {
                _id: o._id || `${o.ref._id}-${optionIndex}`,
                refId: o.ref._id,
                type: o.ref.type,
                displayLabel: o.custom_label || o.ref.name || o.ref.label,
                label: o.custom_label || o.ref.label || o.ref.name,
                name: o.custom_label || o.ref.name,
                options: o.ref.options.map((v) => v._id),
                selected: "",
                min: o.ref.min,
                max: o.ref.max,
                multiple: o.ref.multiple,
              };
              if (op.type == "select" && op.multiple) op.selected = [];
              else if (op.type == "number") op.selected = o.ref.min;
              else op.selected = "";

              return op;
            }) : []
          this.activeOptionIndex = 0;
          this.applyProductDraft();
          this.$nextTick(() => {
            this.$emit("update", {
              loaded: true,
              pid: pid,
              name: res.data.data.name || "",
              pageTitle: document.title || `${res.data.data.name || ""}`.toUpperCase(),
              path: this.$route ? this.$route.fullPath : window.location.pathname + window.location.search,
            });
          });
        })
        .finally(() => (this.loading = false));
    },
    getSelected(selected) {
      if (typeof selected == "number") return selected;
      if (selected == "" || selected == null) return "Nada aun";
      if (Array.isArray(selected)) {
        return selected.map((s) => s.name).join(",");
      } else if (selected.name) return selected.name;
      return selected;
    },
    // getSelectedText(selected, op) {
    getSelectedText() {
      return "";
      // let result = this.getSelected(selected)
      // if(op.selected != selected) return false
      // if(result == "Nada aun") return ''
      // else return `\n\n\n ${result}`
    },
    isOptionComplete(op) {
      if (!op) return false;
      if (op.type == "number") {
        return Number(op.selected) >= Number(op.min) && Number(op.selected) <= Number(op.max);
      }
      if (op.multiple) {
        return Array.isArray(op.selected) && op.selected.length >= op.min;
      }
      return !(op.selected === "" || op.selected === null);
    },
    isOptionOpen(index) {
      return this.activeOptionIndex === index;
    },
    openOption(index) {
      this.activeOptionIndex = index;
      this.$nextTick(() => {
        const ref = this.$refs[`option-block-${index}`];
        const element = Array.isArray(ref) ? ref[0] : ref;
        if (element && element.scrollIntoView) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    getOptionGuide(op) {
      if (op.type == "number") return `Ingresa un valor entre ${op.min} y ${op.max}.`;
      if (op.multiple) return `Selecciona entre ${op.min} y ${op.max} alternativas.`;
      return "Selecciona una alternativa para continuar.";
    },
    canContinueOption(op) {
      if (!this.useAccordion || !op) return false;
      if (!op.multiple && op.type != "number") return false;
      return this.isOptionComplete(op);
    },
    continueFromOption(index) {
      if (index >= this.options.length - 1) return;
      this.openOption(index + 1);
    },
    setNumberOptionValue(op, value) {
      const min = Number(op.min);
      const max = Number(op.max);
      const nextValue = Math.min(Math.max(Number(value), min), max);
      op.selected = nextValue;
    },
    incrementNumberOption(op) {
      this.setNumberOptionValue(op, Number(op.selected || 0) + 1);
    },
    decrementNumberOption(op) {
      this.setNumberOptionValue(op, Number(op.selected || 0) - 1);
    },
    maybeAdvanceOption(op) {
      if (!this.useAccordion) return;
      const index = this.options.indexOf(op);
      if (index === -1 || !this.isOptionComplete(op)) return;
      if (op.multiple || op.type == "number") return;
      this.continueFromOption(index);
    },
    isIn(op, val) {
      // console.log({
      //   name: val.name,
      //   op,
      //   val
      // })
      if (
        Array.isArray(op.selected) &&
        op.selected.find((o) => o._id == val._id)
      )
        return true;

      return false;
    },
    contains() {
      // return true
    },
    setOption(op, val, parent = null) {
      if (op.multiple) {
        if (!Array.isArray(op.selected)) op.selected = [];
        if (op.selected.indexOf(val) == -1) {
          if (op.selected.length >= op.max) return false;
          op.selected.push(val);
        } else {
          op.selected.splice(op.selected.indexOf(val), 1);
        }
      } else {
        op.selected = val;
      }
      op.parent = parent;
      console.log({ op, val });
      this.maybeAdvanceOption(op);
      this.persistProductDraft();
    },
    changeValue(e) {
      event.preventDefault();
      console.log(e);
    },
    normalizeOptionValue(value) {
      if (!value) return null;
      return {
        _id: value._id,
        name: value.name,
        value: Number(value.value) || 0,
      };
    },
    buildCartOption(option) {
      if (!option) return null;

      if (option.multiple) {
        const values = Array.isArray(option.selected)
          ? option.selected
            .map((value) => this.normalizeOptionValue(value))
            .filter(Boolean)
          : [];

        return {
          _id: option.refId || option._id,
          label: option.label || option.name,
          name: option.name,
          type: option.type,
          multiple: true,
          min: option.min,
          max: option.max,
          selected: values.map((value) => value.name).join(", "),
          values,
          extra: values.reduce(
            (total, value) => total + (Number(value.value) || 0),
            0
          ),
        };
      }

      if (option.type == "number") {
        return {
          _id: option.refId || option._id,
          label: option.label || option.name,
          name: option.name,
          type: option.type,
          multiple: false,
          selected: Number(option.selected) || 0,
          values: [],
          extra: 0,
        };
      }

      const selected = this.normalizeOptionValue(option.selected);
      return {
        _id: option.refId || option._id,
        label: option.label || option.name,
        name: option.name,
        type: option.type,
        multiple: false,
        selected: selected ? selected.name : "",
        values: [],
        extra: selected ? Number(selected.value) || 0 : 0,
      };
    },
    addToCart() {
      let b = false;
      let t = 0;
      this.options.forEach((o) => {
        if (
          (o.selected == "" || o.selected == null) &&
          !Array.isArray(o.selected)
        ) {
          console.log("select vacio o null", o.name);
          if (o.type == "number") return false;
          b = true;
        } else {
          if (o.selected && o.selected.value) t = t + o.selected.value;
          if (o.multiple) {
            o.selected.forEach((_o) => {
              if (_o && _o.value) t = t + _o.value;
            });
          }
        }
        if (
          Array.isArray(o.selected) &&
          o.multiple &&
          o.selected.length < o.min
        ) {
          console.log("no selecciono nada");
          b = true;
        }
      });

      let exist = this.$store.state.products.filter(
        (p) => p._id == this.product._id
      );
      let existQty = exist.reduce((t, c) => t + c.qty, 0);
      if (b) {
        this.$swal({
          icon: "error",
          title: "Debe seleccionar las opciones requeridas",
        });
      } else {
        if (
          this.product.stock &&
          exist &&
          existQty + this.qty > this.product.qty
        ) {
          this.$swal({
            icon: "error",
            title: "No puedes agregar mas existencias al carro.",
          });
          return console.log("Mucha cantidad");
        }
        // if(exist) return false
        const options = this.options
          .map((option) => this.buildCartOption(option))
          .filter(Boolean);

        this.$store.commit("clearProductDraft", this.id);
        const editingCartProduct = this.$store.state.editingCartProduct;
        const productPayload = {
          ...this.product,
          product: this.product._id,
          options,
          qty: this.qty,
          extra: t,
          discount: this.getDiscount,
          details: this.details,
          total: (this.product.value + t) * this.qty - this.getDiscount,
          tempid:
            editingCartProduct &&
            editingCartProduct.productId == this.id &&
            editingCartProduct.tempid
              ? editingCartProduct.tempid
              : Date.now(),
        };

        if (
          editingCartProduct &&
          editingCartProduct.productId == this.id &&
          editingCartProduct.tempid
        ) {
          this.$store.commit("replaceProductByTempid", productPayload);
          this.$store.commit("clearEditingCartProduct");
        } else {
          this.$store.commit("addProduct", productPayload);
        }

        this.$gtag.event("add_to_cart", {
          event_category: "products",
          event_label: "User add product",
          value: 1,
        });

        this.$swal({
          //icon: "success",
          title: this.isEditingCartProduct ? "Producto actualizado" : "Producto agregado",
          buttons: this.isEditingCartProduct
            ? {
                ok: {
                  text: "Aceptar",
                  value: "ok",
                },
              }
            : {
                cart: {
                  text: "Ver mi pedido!",
                  value: "go_cart",
                },
                ok: {
                  text: "Aceptar",
                  value: "ok",
                },
              },
        }).then((val) => {
          if (!this.isEditingCartProduct && val == "go_cart") {
            this.$router.push(this.getLink("pedido"));
          }
          else {
            this.$emit("success");
          }
        });
      }
    },
    back() {
      this.$router.back();
    },
    getValues(values = []) {
      return values.split(",");
    },
  },
  mounted() {
    console.log("Product mounted", this.id);
    this.load();
  },
  watch: {
    total() {
      console.log("emit");
      let discount = "";
      if (this.getDiscount)
        discount = `(-$${this.formatNumber(this.getDiscount)})`;

      this.$emit(
        "update",
        `${this.product.name} - $${this.formatNumber(this.total)} ${discount}`
      );
    },
    qty() {
      if (this.qty < 1) {
        this.$swal({
          title: "Error",
          text: "Debe ingresar una cantidad valida (1 o más)",
        });
        this.qty = 1;
      }
      this.persistProductDraft();
    },
    details() {
      this.persistProductDraft();
    },
    activeOptionIndex() {
      this.persistProductDraft();
    },
    options: {
      deep: true,
      handler() {
        this.persistProductDraft();
      },
    },
    id() {
      this.load();
    },
  },
};
</script>
